import React, { useContext } from "react";
import SelectBox from "components/FormElements/SelectBox";
import Label from "components/FormElements/Label";
import { connect } from "react-redux";
import { ContainerContext } from "context/Container";

function WorkflowField(props) {
    const { state } = useContext(ContainerContext);

    if (state.loading) {
        return (
            <div>
                <Label>Workflow Status</Label>
                <div className="mt-1 h-9 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
            </div>
        );
    }

    return (
        <SelectBox
            label="Workflow Status"
            name="workflow"
            id="workflow"
            disabled={
                state.loading ||
                state.preformingStateChange ||
                !state.isUserEditable
            }
            options={props.contentFlow.workflows
                .filter((workflow) => parseInt(workflow.is_content) === 1)
                .map((workflow) => {
                    return {
                        value: workflow.id,
                        label: workflow.name,
                    };
                })}
        />
    );
}

export default connect((state) => {
    return { contentFlow: state.contentFlow };
})(WorkflowField);
